const objectToDataAttrs = (dataAttrs) =>
    Object.entries(dataAttrs || {}).reduce((acc, [k, v]) => `${acc} data-${k}="${v}"`, "");

export default objectToDataAttrs;
